import React from "react";

interface PlayButtonIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const PlayButtonIcon: React.FC<PlayButtonIconProps> = ({
  width = 16,
  height = 16,
  fill = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M5.98736 11.9976C5.81737 11.9976 5.64737 11.9521 5.49368 11.8611C5.18397 11.6767 5 11.3486 5 10.9823V5.01714C5 4.65075 5.18397 4.32268 5.49368 4.13829C5.80339 3.9539 6.17132 3.9539 6.48104 4.13829L11.5063 7.12205C11.816 7.30644 12 7.63451 12 8.0009C12 8.36728 11.816 8.69535 11.5063 8.87974L6.48104 11.8635C6.32735 11.9545 6.15735 12 5.98736 12V11.9976ZM6.16434 5.33323V10.6662L10.6564 7.9985L6.16434 5.33084V5.33323Z"
        fill={fill}
      />
      <path
        d="M11.5891 16H4.41304C1.98043 16 0 14.0198 0 11.5876V4.41244C0 1.98017 1.98043 0 4.41304 0H11.587C14.0196 0 16 1.98017 16 4.41244V11.5854C16 14.0177 14.0196 15.9978 11.587 15.9978L11.5891 16ZM4.41304 1.08681C2.57826 1.08681 1.08696 2.57791 1.08696 4.41244V11.5854C1.08696 13.4199 2.57826 14.911 4.41304 14.911H11.587C13.4217 14.911 14.913 13.4199 14.913 11.5854V4.41244C14.913 2.57791 13.4217 1.08681 11.587 1.08681H4.41304Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1915_7707">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PlayButtonIcon;
